import React from 'react';
import CustomModel from './CustomModel';
export default class DriverModal extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false,
      driver: {}
    }
    this.detailModal = React.createRef();
  }
  showModal() {
    this.detailModal.current.setState({
      show: true,
    })
  }

  render() {
    return (
      <CustomModel title={this.props.title} body={this.body()} show={this.props.show} hide={this.props.hide} />
    )
  }
  body() {
    const driver = this.props.driver;
    let total = 0, count = 0, strDate = "";
    if (driver) {
      const { rating } = driver;
      if (rating) {
        Object.keys(rating).map(key => {
          total += rating[key].rating;
          count++;
        })
        total /= count;
        total = Math.floor(total);
      }
      if (driver.joinDate) {
        let date = new Date(driver.joinDate);
        let month = date.getMonth() + 1
        strDate = (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + "/" + (month < 10 ? "0" + month : month) + "/" + date.getFullYear();
      }
    }
    return <React.Fragment>
      <div className="modal-body" style={{ padding: 0 }}>
        {
          driver && <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <td width="150">
                  {
                    driver.profilePic ? <img src={driver.profilePic} height="150" alt="" /> : <img src={driver.profilePic} alt="No Pic" />
                  }
                </td>
                <td>
                  <ul>
                    <li className="row">
                      <div className="col-lg-6"><strong>Driver Name</strong></div>
                      <div className="col-lg-6">{driver.fullName}</div>
                    </li>
                    <li className="row">
                      <div className="col-lg-6"><strong>Email</strong></div>
                      <div className="col-lg-6">{driver.email}</div>
                    </li>
                    <li className="row">
                      <div className="col-lg-6"><strong>Phone Number</strong></div>
                      <div className="col-lg-6">{driver.phoneNumber}</div>
                    </li>
                    <li className="row">
                      <div className="col-lg-6"><strong>Ratings</strong></div>
                      <div className="col-lg-6">
                        {[...Array(total)].map((x, i) =>
                          <i className="fa fa-star check" key={i}></i>
                        )}
                        {[...Array(5 - total)].map((x, i) =>
                          <i className="fa fa-star " key={i}></i>
                        )}
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-lg-6"><strong>Status</strong></div>
                      <div className="col-lg-6">
                        {driver.verified ?
                          <i className="fa fa-check-circle text-success"></i> :
                          <i className="fa fa-times-circle text-danger"></i>}
                      </div>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <li className="row">
                    <div className="col-sm-12 text-center "><strong> Earnings Info</strong></div>
                  </li>
                  <li className="row">
                    <div className="col-sm-6 text-right"><strong>Total Earnings</strong></div>
                    <div className="col-sm-6">$ {driver.tripData.totalEarning}</div>
                  </li>
                  <li className="row">
                    <div className="col-sm-6 text-right"><strong>Total Withdraw</strong></div>
                    <div className="col-sm-6">$ {driver.tripData.totalWithdraw}</div>
                  </li>
                  <li className="row">
                    <div className="col-sm-6 text-right"><strong>Last Withdraw</strong></div>
                    <div className="col-sm-6">$ {driver.tripData.lastWithdraw}</div>
                  </li>
                  <li className="row">
                    <div className="col-sm-6 text-right"><strong>Balance</strong></div>
                    <div className="col-sm-6">$ {driver.tripData.totalEarning - driver.tripData.totalWithdraw}</div>
                  </li>
                </td>
              </tr>
              <tr>
                <td><strong>Address</strong></td>
                <td>{driver.address}</td>
              </tr>
              <tr>
                <td><strong>Driver Company</strong></td>
                <td>{driver.company}</td>
              </tr>
              <tr>
                <td><strong>Registration Date</strong></td>
                <td>{strDate}</td>
              </tr>
            </tbody>
          </table>
        }
      </div>
      {this.props.footer}
    </React.Fragment>
  }
}


// WEBPACK FOOTER //
// ./src/modal/DriverModal.js